import type { Plant } from '@/data/plants';
import type { UserGardenLocation } from '@/lib/userGardenLocation';

type PlantNativeRange = NonNullable<Plant['nativeRange']>;

export function nativeRangeHasDisplayableData(nativeRange: PlantNativeRange): boolean {
  return nativeRange.importStatus !== 'failed' && (
    nativeRange.regions.some(region => region.code.trim().length > 0) ||
    Boolean(nativeRange.origin?.trim()) ||
    Boolean(nativeRange.nativeHabitat?.trim()) ||
    Boolean(nativeRange.currentDistribution?.trim()) ||
    Boolean(nativeRange.broaderNativeRange?.some(range => range.trim().length > 0))
  );
}

export function nativeRangeHasNativeSubdivisionRows(nativeRange: PlantNativeRange): boolean {
  return nativeRange.regions.some(region =>
    region.code.trim().length > 0 &&
    region.status === 'native',
  );
}

export function nativeRangeCanMatchSubdivision(nativeRange: PlantNativeRange): boolean {
  if (!nativeRangeHasNativeSubdivisionRows(nativeRange)) return false;
  if (nativeRange.reviewStatus === 'reviewed') return true;

  return nativeRange.importStatus === 'imported' &&
    nativeRange.importConfidence === 'high';
}

export function plantIsNativeToSubdivision(
  plant: Pick<Plant, 'nativeRange'>,
  location: UserGardenLocation | null | undefined,
): boolean {
  if (!location) return false;
  const nativeRange = plant.nativeRange;
  if (!nativeRange || !nativeRangeCanMatchSubdivision(nativeRange)) return false;

  const subdivisionCode = location.subdivisionCode.trim().toUpperCase();
  return nativeRange.regions.some(region =>
    region.code.trim().toUpperCase() === subdivisionCode &&
    region.status === 'native',
  );
}
